module.exports = __webpack_public_path__ + "img/02—02—Device List > Dropdown.1ff51f7b.jpg";